import React from 'react'
import ReactDOM from 'react-dom'
import store from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

// Styles Global Imports
import '@tds/css'
import '@fontsource/roboto'

// Babel Regeneration Runtime Imports
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import MainLayout from './components/MainLayout/MainLayout'

class App extends React.Component {
    render() {
        return <MainLayout />
    }
}

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>,
    document.getElementById('root'),
)
